import React, { useState } from "react";

import { ChevronRight } from "react-feather";
import { Collapse } from "reactstrap";
import { NavLink } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import { connect } from "react-redux";
import { setSidebarToggleMobile } from "../../reducers/ThemeOptions";

const SidebarMenu = (props) => {
  // setSidebarToggleMobile,
  const { menu = JSON.parse(localStorage.getItem("menu")) } = props;

  const [toggleSubmenu, setToggleMenu] = useState("dashboard");

  return (
    <>
      <PerfectScrollbar>
        <div className="sidebar-navigation">
          {menu &&
            menu.map((el, idx) => (
              <React.Fragment key={idx + el.name}>
                <ul>
                  <li>
                    <NavLink
                      activeClassName={
                        toggleSubmenu === el.name ? "active" : ""
                      }
                      onClick={() =>
                        toggleSubmenu === el.name
                          ? setToggleMenu("")
                          : setToggleMenu(el.name)
                      }
                      className="nav-link-simple"
                      to={el.route}>
                      <span className="sidebar-icon">{/* <Gift /> */}</span>
                      {el.label}
                      <span className="sidebar-icon-indicator sidebar-icon-indicator-right">
                        <ChevronRight />
                      </span>
                    </NavLink>
                    {Array.isArray(el.items) && el.items.length && (
                      <Collapse isOpen={toggleSubmenu === el.name}>
                        <ul style={{ paddingLeft: "1.2rem" }}>
                          {el.items.map((element, index) => (
                            <li key={index + el.name}>
                              <NavLink
                                className="nav-link-simple"
                                to={element.route}>
                                <span className="sidebar-icon"></span>
                                {element.label}
                                <span className="sidebar-icon-indicator sidebar-icon-indicator-right">
                                  <ChevronRight />
                                </span>
                              </NavLink>
                              {Array.isArray(element.items) &&
                                element.items.length && (
                                  <Collapse isOpen={true}>
                                    <ul style={{ paddingLeft: "1.5rem" }}>
                                      {element.items.map((subElement, idx1) => (
                                        <li key={idx1 + subElement.name}>
                                          <NavLink
                                            className="nav-link-simple"
                                            to={subElement.route}>
                                            <span className="sidebar-icon"></span>
                                            {subElement.label}
                                            <span className="sidebar-icon-indicator sidebar-icon-indicator-right">
                                              <ChevronRight />
                                            </span>
                                          </NavLink>
                                        </li>
                                      ))}
                                    </ul>
                                  </Collapse>
                                )}
                            </li>
                          ))}
                        </ul>
                      </Collapse>
                    )}
                  </li>
                </ul>
              </React.Fragment>
            ))}
        </div>
      </PerfectScrollbar>
    </>
  );
};

const mapStateToProps = ({ ThemeOptions, AuthUser }) => ({
  menu: AuthUser.menu,
  sidebarUserbox: ThemeOptions.sidebarUserbox,
  sidebarToggleMobile: ThemeOptions.sidebarToggleMobile
});

const mapDispatchToProps = (dispatch) => ({
  setSidebarToggleMobile: (enable) => dispatch(setSidebarToggleMobile(enable))
});

export default connect(mapStateToProps, mapDispatchToProps)(SidebarMenu);
